/**
 * EBP Delivery Widget v3.2 — Production Ready
 */
(function () {
  'use strict';

  const WORKER_URL = 'https://ebpapicors.salhiabdu1910.workers.dev';
  const HOVER_DELAY = 120;

  function log(...a){ console.log('[EBP v3]',...a); }

  // ── City lookup from ZIP ───────────────────────────────────────────────────
  async function zipToCity(zip) {
    if (!zip) return null;
    try {
      const r1 = await fetch('https://api.zippopotam.us/us/' + zip);
      if (r1.ok) {
        const d = await r1.json();
        const p = d.places && d.places[0];
        if (p) return p['place name'] + ', ' + p['state abbreviation'];
      }
    } catch(e) {}
    try {
      const r2 = await fetch('https://ipapi.co/' + zip + '/json/');
      if (r2.ok) {
        const d = await r2.json();
        if (d.city && d.region_code) return d.city + ', ' + d.region_code;
      }
    } catch(e) {}
    return null;
  }

  function normalizeSKU(sku) {
    if (!sku) return null;
    return sku.replace(/[-\/]/g, '').trim();
  }

  // ── Fetch from worker ──────────────────────────────────────────────────────
  async function fetchDelivery(sku, zip) {
    try {
      const params = '/?sku=' + encodeURIComponent(sku) + (zip ? '&zip=' + encodeURIComponent(zip) : '');
      const res = await fetch(WORKER_URL + params);
      const json = await res.json();
      log('Worker response — freight:', json.freight, '| delivery:', !!json.delivery);

      // Freight product — category detected by worker
      if (json.freight) return { freight: true };

      // Normal delivery data
      if (json.delivery) return json;

      return null;
    } catch(e) {
      log('Fetch error:', e.message);
      return null;
    }
  }

  // ── Date helpers ───────────────────────────────────────────────────────────
  const DAYS   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function parseDate(str) {
    const s = str.replace(/-/g,'');
    return new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
  }

  function friendly(str) {
    const d = parseDate(str);
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function fmtCountdown(m) {
    if (!m || m <= 0) return null;
    const h = Math.floor(m/60), r = m%60;
    return h > 0 ? h+'h '+r+'m' : r+'m';
  }

  function todayFriendly() {
    const d = new Date();
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  // ── HTML Builders ──────────────────────────────────────────────────────────
  function buildFreight() {
    return `
      <div class="ebp-delivery">
        <div class="ebp-delivery__top">
          <div class="ebp-delivery__location">
            <svg class="ebp-location__pin" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
            <span class="ebp-location__text">
              📦 This item ships via <strong class="ebp-location__city">Freight / LTL</strong>
            </span>
          </div>
          <div class="ebp-delivery__range">
            🚚 Estimated delivery: <strong class="ebp-range__date">7 business days</strong> from order date
          </div>
        </div>
      </div>`;
  }

  function buildSkeleton() {
    return `<div class="ebp-delivery ebp-delivery--loading">
      <div class="ebp-skeleton-line" style="width:45%;height:13px;margin-bottom:10px;"></div>
      <div class="ebp-skeleton-line ebp-skeleton-line--short"></div>
      <div class="ebp-delivery__timeline" style="padding-top:14px;">
        <div class="ebp-timeline__step"><div class="ebp-skeleton-circle"></div><div class="ebp-skeleton-line ebp-skeleton-line--tiny"></div></div>
        <div class="ebp-timeline__line"></div>
        <div class="ebp-timeline__step"><div class="ebp-skeleton-circle"></div><div class="ebp-skeleton-line ebp-skeleton-line--tiny"></div></div>
        <div class="ebp-timeline__line"></div>
        <div class="ebp-timeline__step"><div class="ebp-skeleton-circle"></div><div class="ebp-skeleton-line ebp-skeleton-line--tiny"></div></div>
      </div>
    </div>`;
  }

  let _cid = 0;

  function buildFallback() {
    const cid = ++_cid;
    return `
      <div class="ebp-delivery">
        <div class="ebp-delivery__top">
          <div class="ebp-delivery__location">
            <svg class="ebp-location__pin" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
            <span class="ebp-location__text">Enter your ZIP for delivery estimate</span>
          </div>
          <div class="ebp-zip-form active" id="ebpzf${cid}">
            <input class="ebp-zip-input" id="ebpzi${cid}" type="text" placeholder="Enter ZIP code" maxlength="10"
              onkeydown="if(event.key==='Enter') window.__ebpZip && window.__ebpZip('${cid}')">
            <button class="ebp-zip-btn" onclick="window.__ebpZip && window.__ebpZip('${cid}')">Check</button>
          </div>
        </div>
      </div>`;
  }

  function buildWidget(delivery, cid) {
    const today  = todayFriendly();
    const shipF  = friendly(delivery.shipDate.replace(/-/g,''));
    const delF   = friendly(delivery.deliveryDate.replace(/-/g,''));
    const cd     = fmtCountdown(delivery.minutesUntilCutoff);
    const city   = delivery._cityLabel || ('ZIP ' + (delivery.customerZip || '10001'));

    const cdHTML = cd && delivery.shipsToday ? `
      <div class="ebp-delivery__countdown">
        ⏰ Order within <strong class="ebp-countdown__time">${cd}</strong> and it will arrive by <strong class="ebp-countdown__arrive">${delF}</strong>
      </div>` : '';

    const backupHTML = '';

    return `
      <div class="ebp-delivery">
        <div class="ebp-delivery__top">
          <div class="ebp-delivery__location">
            <svg class="ebp-location__pin" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
            <span class="ebp-location__text">Delivering to <span class="ebp-location__city">${city}</span></span>
            <button class="ebp-location__edit" onclick="
              var f=document.getElementById('ebpzf${cid}');
              f.classList.toggle('active');
              if(f.classList.contains('active')) document.getElementById('ebpzi${cid}').focus();
            ">Change</button>
          </div>
          <div class="ebp-zip-form" id="ebpzf${cid}">
            <input class="ebp-zip-input" id="ebpzi${cid}" type="text" placeholder="Enter ZIP code" maxlength="10"
              onkeydown="if(event.key==='Enter') window.__ebpZip && window.__ebpZip('${cid}')">
            <button class="ebp-zip-btn" onclick="window.__ebpZip && window.__ebpZip('${cid}')">Update</button>
          </div>
          ${cdHTML}
          ${backupHTML}
          <div class="ebp-delivery__range">
            🚚 Estimated delivery: <strong class="ebp-range__date">${delF}</strong>
          </div>
        </div>
        <div class="ebp-delivery__timeline-box">
          <div class="ebp-delivery__timeline">
            <div class="ebp-timeline__step">
              <div class="ebp-timeline__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                  <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                </svg>
              </div>
              <div class="ebp-timeline__label">Ordered</div>
              <div class="ebp-timeline__date">${today}</div>
            </div>
            <div class="ebp-timeline__line"></div>
            <div class="ebp-timeline__step">
              <div class="ebp-timeline__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                  <rect x="1" y="3" width="15" height="13"/>
                  <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                  <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
                </svg>
              </div>
              <div class="ebp-timeline__label">Shipped</div>
              <div class="ebp-timeline__date ebp-timeline__date--highlight">${shipF}</div>
            </div>
            <div class="ebp-timeline__line"></div>
            <div class="ebp-timeline__step">
              <div class="ebp-timeline__icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div class="ebp-timeline__label">Delivered</div>
              <div class="ebp-timeline__date ebp-timeline__date--highlight">${delF}</div>
            </div>
          </div>
        </div>
      </div>`;
  }

  function buildHint(delivery) {
    const delF = friendly(delivery.deliveryDate.replace(/-/g,''));
    const cd   = fmtCountdown(delivery.minutesUntilCutoff);
    const cdText = cd && delivery.shipsToday
      ? `<span class="ebp-hint__countdown">⏰ ${cd}</span>` : '';
    return `
      <div class="ebp-hint">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <rect x="1" y="3" width="15" height="13"/>
          <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
        <span class="ebp-hint__text">Arrives <strong>${delF}</strong></span>
        ${cdText}
      </div>`;
  }

  function buildHintLoading() {
    return `<div class="ebp-hint ebp-hint--loading">
      <div class="ebp-skeleton-line" style="width:100%;height:9px;margin:0;border-radius:4px;"></div>
    </div>`;
  }

  // ── Init Widget (Product Page) ─────────────────────────────────────────────
  async function initWidget(container, rawSku, customZip) {
    if (!rawSku) { container.innerHTML = ''; return; }
    const sku = normalizeSKU(rawSku);
    if (!sku) { container.innerHTML = ''; return; }

    // ── Case 1: Weight >= 95 lbs → Freight (checked from Shopify product data)
    const weight = parseFloat(container.dataset.ebpWeight) || 0;
    if (weight >= 75) {
      log('Freight by weight:', weight, 'lbs');
      container.innerHTML = buildFreight();
      return;
    }

    container.innerHTML = buildSkeleton();

    // Resolve customer ZIP
    let resolvedZip = customZip;
    if (!resolvedZip) {
      try { const s = localStorage.getItem('ebp3_customer_zip'); if (s) resolvedZip = s; } catch(e){}
    }
    if (!resolvedZip) resolvedZip = '10001';

    const data = await fetchDelivery(sku, resolvedZip);

    // ── Case 2: Freight by category → detected by Cloudflare Worker
    if (data && data.freight) {
      log('Freight by category');
      container.innerHTML = buildFreight();
      return;
    }

    // ── Case 3: No data → show ZIP input fallback
    if (!data || !data.delivery) {
      container.innerHTML = buildFallback();
      window.__ebpZip = function(id) {
        const input = document.getElementById('ebpzi' + id);
        const zip = input ? input.value.trim() : null;
        if (!zip || zip.length < 5) return;
        try { localStorage.setItem('ebp3_customer_zip', zip); } catch(e){}
        initWidget(container, rawSku, zip);
      };
      return;
    }

    // ── Case 4: Normal delivery → show full widget
    const cityLabel = await zipToCity(resolvedZip);
    data.delivery._cityLabel = cityLabel || ('ZIP ' + resolvedZip);

    const cid = ++_cid;
    container.innerHTML = buildWidget(data.delivery, cid);

    window.__ebpZip = function(id) {
      const input = document.getElementById('ebpzi' + id);
      const zip = input ? input.value.trim() : null;
      if (!zip || zip.length < 5) return;
      try { localStorage.setItem('ebp3_customer_zip', zip); } catch(e){}
      initWidget(container, rawSku, zip);
    };
  }

  // ── Product Page ───────────────────────────────────────────────────────────
  function initProductPage() {
    const container = document.querySelector('.ebp-product-widget');
    if (!container) return;
    initWidget(container, container.dataset.ebpSku);

    document.addEventListener('variant:changed', function(e) {
      const s = e.detail && e.detail.variant && e.detail.variant.sku;
      if (s) { container.dataset.ebpSku = s; initWidget(container, s); }
    });

    const skuEl = document.querySelector('.product-sku__value');
    if (skuEl) {
      new MutationObserver(function() {
        const s = skuEl.textContent.trim();
        if (s && s !== container.dataset.ebpSku) { container.dataset.ebpSku = s; initWidget(container, s); }
      }).observe(skuEl, { childList:true, characterData:true, subtree:true });
    }
  }

  // ── Collection Page ────────────────────────────────────────────────────────
  async function initHint(container, rawSku) {
    const sku = normalizeSKU(rawSku);
    if (!sku) return;
    container.innerHTML = buildHintLoading();
    container.style.display = 'block';
    let resolvedZip = '10001';
    try { const s = localStorage.getItem('ebp3_customer_zip'); if (s) resolvedZip = s; } catch(e){}
    const data = await fetchDelivery(sku, resolvedZip);
    // Hide hint for freight products or no data
    if (!data || data.freight || !data.delivery) {
      container.style.display = 'none';
      container.innerHTML = '';
      return;
    }
    container.innerHTML = buildHint(data.delivery);
    container.style.display = 'block';
  }

  const _prefetchCache = {};

  function initCollectionPage() {
    const cards = document.querySelectorAll('product-card[data-ebp-sku]');
    if (!cards.length) return;
    const isMobile = () => window.innerWidth < 768;

    // Prefetch first 6 cards in background
    let resolvedZip = '10001';
    try { const s = localStorage.getItem('ebp3_customer_zip'); if (s) resolvedZip = s; } catch(e){}
    Array.from(cards).slice(0, 6).forEach(function(card, i) {
      const sku = normalizeSKU(card.dataset.ebpSku);
      if (!sku) return;
      setTimeout(async () => {
        try {
          const data = await fetchDelivery(sku, resolvedZip);
          if (data) { _prefetchCache[sku] = data; log('Prefetched:', sku); }
        } catch(e) {}
      }, i * 400);
    });

    cards.forEach(function(card) {
      const rawSku = card.dataset.ebpSku;
      const sku = normalizeSKU(rawSku);
      const container = card.querySelector('.ebp-collection-widget');
      if (!container || !sku) return;

      let fetched = false, timer = null;

      const show = () => {
        container.style.display = 'block';
        if (fetched) return;
        fetched = true;

        const cached = _prefetchCache[sku];
        if (cached) {
          // Freight product — hide hint
          if (cached.freight || !cached.delivery) {
            container.style.display = 'none';
            return;
          }
          container.innerHTML = buildHint(cached.delivery);
        } else {
          initHint(container, rawSku);
        }
      };

      const hide = () => { container.style.display = 'none'; };

      if (!isMobile()) {
        card.addEventListener('mouseenter', () => { timer = setTimeout(show, HOVER_DELAY); });
        card.addEventListener('mouseleave', () => { clearTimeout(timer); hide(); });
      } else {
        let tapped = false;
        card.addEventListener('click', function(e) {
          const l = e.target.closest('a'); if (!l) return;
          if (!tapped) { e.preventDefault(); tapped = true; show(); }
        }, {capture: true});
        document.addEventListener('click', function(e) {
          if (!card.contains(e.target)) { hide(); tapped = false; }
        });
      }
    });
  }

  // ── Boot ───────────────────────────────────────────────────────────────────
  function boot() {
    if (document.querySelector('.ebp-product-widget')) initProductPage();
    if (document.querySelector('product-card[data-ebp-sku]')) initCollectionPage();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

})();